<template>
  <div class="statistic-variant">
    <div class="statistic-variant__top">
      <div class="statistic-variant__letter-wrapper">
        <div
          class="statistic-variant__letter"
          :style="{ background: `${getColor}` }"
        >
          {{ getLetter }}
        </div>
        <div
          v-if="typeof successPercentage === 'number'"
          class="statistic-variant__letter-percentage"
          :style="{ color: `${getColor}` }"
        >
          {{ roundNumber(successPercentage, 3) }}%
        </div>
      </div>

      <div class="statistic-variant__title">
        {{ title }} – {{ percentage }}% of traffic
      </div>
    </div>
    <div class="statistic-variant__statistic">
      <div class="statistic-variant__statistic-item">
        <div class="statistic-variant__success-count">{{ success }}</div>
        <div class="statistic-variant__statistic-prop">
          Successful Impressions
        </div>
      </div>
      <div class="statistic-variant__statistic-item">
        <div class="statistic-variant__total-count">{{ total }}</div>
        <div class="statistic-variant__statistic-prop">Total Impressions</div>
      </div>
    </div>
  </div>
</template>

<script>
import { roundNumber } from "@/shared/lib/numbers";

export default {
  props: {
    percentage: {
      type: Number,
      default: 0,
    },
    successPercentage: {
      type: Number,
      default: 0,
    },
    success: {
      type: Number,
      default: 0,
    },
    total: {
      type: Number,
      default: 0,
    },
    index: {
      type: Number,
      default: 0,
    },
    title: {
      type: String,
      default: "",
    },
  },
  methods: {
    roundNumber,
  },
  computed: {
    getColor() {
      const colors = [
        "#6db90c",
        "#f5c828",
        "#f66141",
        "#3697f1",
        "#9747ff",
        "#979797",
      ];
      return colors[this.index % colors.length] || colors[0];
    },
    getLetter() {
      const letters = ["A", "B", "C", "D", "E", "F"];
      return letters[this.index % letters.length] || letters[0];
    },
  },
};
</script>

<style lang="scss" scoped>
.statistic-variant {
  &__top {
    margin-bottom: 8px;
  }
  &__letter {
    display: flex;
    height: 20px;
    padding: 0 8px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 100px;
    background: #6db90c;
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    color: #fff;
  }
  &__letter-wrapper {
    display: flex;
    align-items: center;
  }
  &__letter-percentage {
    margin-left: 8px;
    font-size: 20px;
    font-weight: 800;
    line-height: 28px;
  }
  &__title {
    color: var(--Color-Text-text-color-secondary, #909399);
    font-size: 12px;
    font-weight: 500;
    line-height: 20px;
  }
  &__statistic {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }
  &__statistic-prop {
    color: var(--Color-Text-text-color-secondary, #909399);
    font-size: 12px;
    font-weight: 500;
    line-height: 20px; /* 166.667% */
  }
  &__success-count {
    color: var(--Color-Text-text-color-primary, #303133);
    font-size: 16px;
    font-weight: 800;
    line-height: 24px; /* 150% */
  }
  &__total-count {
    color: var(--Color-Text-text-color-regular, #606266);
    font-size: 13px;
    font-weight: 800;
    line-height: 22px; /* 169.231% */
  }
}
</style>
